<template>
  <div class="vanguard-payment-form">
    <div v-if="displayPaymentForm && testLevel===constants.TEST_LEVEL_VANGUARD"
         class="vanguard-payment-form-test-submit-button"
         @click.prevent="validateOrder">
      {{ $t('all.testSubmitPayment') }} - {{ $t('all.' + paymentMethod) }}
    </div>
    <div v-else-if="displayPaymentForm && testLevel!==constants.TEST_LEVEL_VANGUARD"
         class="vanguard-payment-iframe-container">
      <div v-if="hasPaymentError" class="vanguard-payment-error-message alert alert-warning">
        {{ $t("all.paymentErrorMessage") }}
      </div>

      <div v-if="isPaymentFormLoading" class="vanguard-spinner-container">
        <div class="spinner-border" role="status">
          <span class="sr-only">{{ $t("all.loading") }}</span>
        </div>
      </div>

      <iframe ref="paymentIFrame"
              v-show="!isPaymentFormLoading"
              :src="iframeUrl"
              allowtransparency="true"
              class="vanguard-payment-iframe"
              :style="`height: ${paymentMethod === constants.PAYMENT_METHOD_SEPA ? iframeHeightPalyance : iframeHeightOgone}px`"
              @load="initPaymentIFrame"></iframe>
    </div>
    <div v-else-if="!displayPaymentForm" class="alert alert-warning">
            <span v-if="isAppMultiple">
              {{ $t('form.fillFormMultiple') }}
            </span>
      <span v-else-if="currentChoiceIsAllowed">
                {{ $t('form.fillForm') }}
            </span>
      <span v-else-if="!currentChoiceIsAllowed">
                {{ $t('form.alreadyPurchased') }}
            </span>
    </div>

    <div v-if="displayBankCheckInstructions">
      <div class="module-block module-block-cheque" v-html="getBankCheckInstructions"></div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Utils from '../modules/utils';
import VanguardConfig from '../../../config/vanguard';
import MixinCookies from '../mixins/cookies';
import * as constants from '../constants';
import * as mutations from '../store/mutations';
import MixinShippingPrice from '@/common/mixins/shipping-price';


export default {
  data() {
    return {
      constants,
      iframeUrl: '',
      ogoneFormHTML: '',
      isPaymentFormLoading: false,
      hasPaymentError: false,
      iframeHeightPalyance: 450,
      iframeHeightOgone: 520
    };
  },
  mixins: [
    MixinCookies,
    MixinShippingPrice
  ],
  computed: {
    ...mapGetters([
      'locale',
      'paymentMethod',
      'formIsValid',
      'formData',
      'conditionsApproved',
      'cgsApproved',
      'currentChoiceSfId',
      'currentChoiceIsAllowed',
      'currentOrderUid',
      'testLevel',
      'sentry',
      'globalConfig',
      'doubleOptin',
      'paymentId',
      'mandateId',
      'currentChoiceConfig',
      'journeyConfig',
      'affiliateConfig',
      'trackingCode',
      'paymentAccountIdentifier',
      'pciToken',
      'holderName',
      'useSameAddressForShipping',
      'isAspspEligible',
      'isAspspEligibleBankCard',
      'isAspspEligibleSepa',
      'aspspEmail',
      'billingCountry',
      'shippingCountry',
      'currentBillingEmail',
      'getTotalAmount'
    ]),
    /**
     * Conditions to display payment IFrame:
     * - a choice is selected
     * - the choice is allowed (not already ordered if config does not allow multiple orders)
     * - the contact form is valid
     * - Terms and Conditions are approved (optin)
     *
     * 2 payment modes:
     * - sepa: palyance
     * - cc:   ogone
     */
    displayPaymentForm() {
      if(!this.conditionsApproved || !this.cgsApproved) {
        return false;
      }

      if (this.isAppMultiple) {
        return this.formIsValid ||
            ((this.isAspspEligibleSepa && this.paymentMethod === constants.PAYMENT_METHOD_SEPA) || (this.isAspspEligibleBankCard && this.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD));
      }

      return (this.currentChoiceSfId && this.currentChoiceIsAllowed && this.formIsValid) ||
          ((this.isAspspEligibleSepa && this.paymentMethod === constants.PAYMENT_METHOD_SEPA) || (this.isAspspEligibleBankCard && this.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD));
    },
    /**
     * Return the right URL according to current environment, development or production
     */
    palyanceUrl() {
      return VanguardConfig.palyanceUrl;
    },
    displayBankCheckInstructions() {
      if (typeof this.currentChoiceConfig !== 'undefined' &&
          typeof this.currentChoiceConfig.acceptBankCheck !== 'undefined' &&
          this.currentChoiceConfig.acceptBankCheck === true) {
        return true;
      }

      return false;
    },
    getBankCheckInstructions() {
      const placeholderOrderTotal = '{{orderTotal}}';
      const placeholderCurrencyIsoCode = '{{currencyIsoCode}}';
      const placeholderPromoCode = '{{promoCode}}';

      const countryCode = this.useSameAddressForShipping ? this.billingCountry : this.shippingCountry;
      const choicePrice = this.currentChoiceConfig.price;

      let shippingAmount = 0;
      if (this.currentChoiceConfig.shippingAmount !== null && (typeof this.currentChoiceConfig.shippingAmount[countryCode] !== 'undefined')) {
        shippingAmount = this.currentChoiceConfig.shippingAmount[countryCode];
      }

      const orderTotal = parseFloat((parseInt(choicePrice * 100, 10) + parseInt(shippingAmount * 100, 10)) / 100); // Avoid float calc issues
      const {currencyIsoCode} = VanguardConfig;
      const trackingCode = this.currentChoiceConfig.name + '-' + this.trackingCode;

      let textReplaced = '';

      if (typeof this.affiliateConfig.bankCheckInstructions !== 'undefined' && this.affiliateConfig.bankCheckInstructions) {
        textReplaced = this.affiliateConfig.bankCheckInstructions.replace(placeholderOrderTotal, orderTotal.toFixed(2))
            .replace(placeholderCurrencyIsoCode, currencyIsoCode)
            .replace(placeholderPromoCode, trackingCode);
      }

      return textReplaced;
    },
    isAppMultiple() {
      return typeof this.currentChoiceConfig === 'undefined';
    }
  },
  methods: {
    updatePaymentForm() {
      // If test level is "vanguard_only", we do not display the IFrame
      if (this.testLevel === constants.TEST_LEVEL_VANGUARD || !this.displayPaymentForm) {
        return;
      }

      const totalAmount = parseFloat(this.getTotalAmount); // Get choice total amount

      let currentShippingPrice = this.getCurrentShippingPrice();
      if (currentShippingPrice === '' || currentShippingPrice === 'null') {
        currentShippingPrice = '0';
      }

      const shippingPrice = parseFloat(currentShippingPrice); // Get shipping price given current selected country

      const amount = (totalAmount + shippingPrice).toFixed(2);

      this.isPaymentFormLoading = true;
      if (this.paymentMethod === constants.PAYMENT_METHOD_SEPA) {
        this.iframeUrl = `${this.palyanceUrl}/sepa/capture/?${this.getPalyanceV2QueryParams(amount)}`;
      }

      if (this.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD) {
        this.iframeUrl = `${this.palyanceUrl}/bankcard/capture/?${this.getPalyanceV2QueryParams(amount)}`;
      }
    },
    updateShippingAndBillingInformations() {
      const isSameAddress = this.useSameAddressForShipping;
      this.billingInformations = {
        type: 'billing',
        firstName: this.formData.billing.billingFirstName,
        lastName: this.formData.billing.billingLastName,
        address: this.formData.billing.billingStreet1,
        address2: this.formData.billing.billingStreet2,
        address3: this.formData.billing.billingStreet3,
        address4: this.formData.billing.billingStreet4,
        phone: this.formData.billing.billingPhoneNumber,
        zipCode: this.formData.billing.billingZipCode,
        city: this.formData.billing.billingCity,
        country: this.formData.billing.billingCountry,
        email: this.formData.billing.billingEmail
      };
      this.shippingInformations = {
        type: 'shipping',
        firstName: isSameAddress ? this.formData.billing.billingFirstName : this.formData.shipping.shippingFirstName,
        lastName: isSameAddress ? this.formData.billing.billingLastName : this.formData.shipping.shippingLastName,
        address: isSameAddress ? this.formData.billing.billingStreet1 : this.formData.shipping.shippingStreet1,
        address2: isSameAddress ? this.formData.billing.billingStreet2 : this.formData.shipping.shippingStreet2,
        address3: isSameAddress ? this.formData.billing.billingStreet3 : this.formData.shipping.shippingStreet3,
        address4: isSameAddress ? this.formData.billing.billingStreet4 : this.formData.shipping.shippingStreet4,
        phone: isSameAddress ? this.formData.billing.billingPhoneNumber : this.formData.shipping.shippingPhoneNumber,
        zipCode: isSameAddress ? this.formData.billing.billingZipCode : this.formData.shipping.shippingZipCode,
        city: isSameAddress ? this.formData.billing.billingCity : this.formData.shipping.shippingCity,
        country: isSameAddress ? this.formData.billing.billingCountry : this.formData.shipping.shippingCountry
      };
    },
    getPalyanceV2QueryParams(amount) {
      const query = Utils.getQueryParams();
      const country = this.formData.billing.billingCountry;
      this.updateShippingAndBillingInformations();
      /**
       * ParamPlus is an object in which we gonna save data for the waiting page
       */
      const paramPlus = {};

      const payload = {
        amount: parseFloat((parseFloat(amount) * 100).toFixed(0)),
        merchantIdentifier: this.affiliateConfig.affiliateId,
        merchantName: this.affiliateConfig.merchantName,
        choiceFreeDays: this.currentChoiceConfig.freeDays,
        defaultLocale: this.mapLanguageToOgoneFormat(this.locale),
        /**
         * Params: query.paymentId (recapture)
         */
        doubleOptin: this.doubleOptin ? 1 : 0,
        lang: this.locale,
        orderId: this.currentOrderUid,
        billingInformations: this.billingInformations,
        shippingInformations: this.shippingInformations,
        technicalContract: this.conditionsApproved ? 1 : 0,
        aspspContract: this.cgsApproved ? 1 : 0,
        sourceUrl: encodeURIComponent(document.location.href),
        formIsValid: this.formIsValid
      };

      if (this.isAspspEligible) {
        const regex = /^[a-zA-Z0-9]*$/;
        const walletId = query.walletIdentifier || query.walletId;
        payload.walletIdentifier = regex.test(walletId) ? walletId : null;
        payload.paymentInformationIdentifier = query.paymentId || this.paymentId;
        payload.mandateIdentifier = this.mandateId;
        payload.paymentInformationObfuscated = this.paymentAccountIdentifier;
        payload.holderName = this.holderName;
        payload.billingInformations = this.billingInformations
        payload.shippingInformations = this.shippingInformations

        if (this.isAspspEligibleBankCard && this.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD) {
          payload.pciToken = this.pciToken;
        }
      }

      payload.totalAmount = payload.amount;

      if (this.isAppMultiple) {
        payload.productName = '';
      } else {
        payload.productName = this.currentChoiceConfig.description;
      }

      const exceptionUrl = `${window.location.origin}${window.location.pathname}`;
      const waitingUrl = `${window.location.origin}/static/${this.locale}/waiting.html`;

      payload.browserData = this.presentBrowserData();
      payload.exceptionUrl = exceptionUrl;
      payload.waitingUrl = waitingUrl;

      if (this.isAspspEligibleSepa && this.paymentMethod === constants.PAYMENT_METHOD_SEPA) {
        payload.waitingUrl = `${window.location.origin}/static/${this.locale}/waiting-double-optin.html`;

        /**
         * To be shown on the waitingPage double optin
         */
        paramPlus.emailDoubleOptin = this.aspspEmail;
        paramPlus.countdownStartTimeMs = Date.now();
      } else {
        payload.waitingUrl = `${window.location.origin}/static/${this.locale}/waiting.html`;
      }

      const pathElements = window.location.pathname.split('/');
      /**
       * If the currentChoiceConfig exists and the nextStepCode too it's a "regular" app
       * If not it's a multiple type app, and the confirmation "step" is always "confirmation"
       */
      if (!this.isAppMultiple && typeof this.currentChoiceConfig.nextStepCode !== 'undefined') {
        pathElements[2] = this.currentChoiceConfig.nextStepCode;
      } else {
        pathElements[2] = 'confirmation';
      }

      pathElements[3] = 'index.html';

      if (window.location.search.length > 0) {
        window.location.search.slice(1).split('&').forEach(pair => {
          const row = pair.split('=');
          paramPlus[row[0]] = row[1];
        });
      }

      paramPlus.orderId = this.currentOrderUid;
      paramPlus.confirmationUrl = `${window.location.origin}${pathElements.join('/')}`;
      paramPlus.exceptionUrl = exceptionUrl;
      paramPlus.paymentType = this.paymentMethod;
      paramPlus.action = 'capture';

      // Store paramPlus into the localStorage
      // We will use those data on the waiting page
      localStorage.setItem(constants.VANGUARD_LOCALSTORAGE_KEY, JSON.stringify(paramPlus));

      const queryParams = new URLSearchParams();
      queryParams.append('json', JSON.stringify(payload));

      return queryParams.toString();
    },
    /**
     * Receive messages from payment IFrame
     * @param event
     */
    iframeMessageCallback(event) {
      // Check whether message origin is Palyance origin
      if (event.origin !== this.palyanceUrl) {
        this.$log.debug('Origin does not match with Palyance origin', event);
        return;
      }

      if (event && event.data && typeof event.data.FrameHeightPalyance !== 'undefined') {
        this.$log.debug('event.data.FrameHeightPalyance', event.data.FrameHeightPalyance);
        this.iframeHeightPalyance = event.data.FrameHeightPalyance;
        return;
      }

      const response = event.data;
      if (typeof response.isLoaded !== 'undefined') {
        return;
      }

      // If an error occurred, display error message then reset IFrame
      if (!response.status) {
        this.$log.error('Palyance Payment error', response.data);
        this.hasPaymentError = true;
      }
    },
    /**
     * This method is called ONLY when vanguard_only
     */
    validateOrder() {
      this.$store.commit(mutations.SET_ORDER_COMPLETE, true);
    },
    presentBrowserData() {
      if (typeof window.screen === 'undefined') {
        window.screen = {};
      }

      if (typeof window.navigator === 'undefined' || typeof window.navigator.javaEnabled !== 'function') {
        window.navigator = {
          javaEnabled() {
            return false;
          }
        };
      }

      return {
        colorDepth: window.screen.colorDepth,
        javaEnabled: window.navigator.javaEnabled().toString(),
        language: window.navigator.language,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timeZone: new Date().getTimezoneOffset()
      };
    },
    initPaymentIFrame() {
      this.isPaymentFormLoading = false;
      // Listen to IFrame messages to retrieve payment data
      window.addEventListener('message', this.iframeMessageCallback, false);

      if (!this.$refs.paymentIFrame) {
        this.sendError('Unable to retrieve payment IFrame DOM node');
      }

      const paymentIFrame = this.$refs.paymentIFrame.contentWindow;
      paymentIFrame.postMessage('FrameHeightPalyance', '*');

      console.log('storeCookies and local storage before calling palyance');
      this.storeCookiesBeforeRedirectingToConfirmPage();
    },
    sendError(message) {
      this.$log.error(message);
      this.sentry.withScope(scope => {
        scope.setLevel('fatal');
        scope.setExtra('paymentMethod', this.paymentMethod);
        scope.setExtra('currentChoiceSfId', this.currentChoiceSfId);
        scope.setExtra('currentOrderUid', this.currentOrderUid);
        scope.setExtra('affiliateId', this.affiliateConfig.affiliateId);
        scope.setExtra('URL', document.location.href);
        this.sentry.captureMessage(message);
      });
    },
    mapLanguageToOgoneFormat(lang) {
      const langMap = {
        'fr': 'fr_FR',
        'en': 'en_GB',
        'es': 'es_ES',
        'de': 'de_DE',
        'it': 'it_IT'
      };
      return langMap[lang] || 'fr_FR';
    }
  },
  mounted() {
    // Create and dispatch the mounted event
    const event = new CustomEvent('vanguard-payment-form-mounted', {});
    document.dispatchEvent(event);
  },
  watch: {
    paymentMethod(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.updatePaymentForm();
    },
    currentChoiceSfId(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.updatePaymentForm();
    },
    getTotalAmount() {
      this.updatePaymentForm();
    },
    formData() {
      this.updatePaymentForm();
    },
    /**
     * On contact-form invalid we refresh the iFrame
     */
    formIsValid(isValid) {
      if (!isValid && !((this.isAspspEligibleSepa && this.paymentMethod === constants.PAYMENT_METHOD_SEPA) || (this.isAspspEligibleBankCard && this.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD))) {
        return;
      }
      this.updatePaymentForm();
    },
    useSameAddressForShipping() {
      this.updateShippingAndBillingInformations();
      this.updatePaymentForm();
    }

  }
};
</script>



// WEBPACK FOOTER //
// payment-form.vue?2d9cb17c